// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__Aafe3","achievement":"Stats_achievement__y6xhu","circle":"Stats_circle__J3jLJ"};